<template>
  <div class="panel app_store">
    <div class="panel_title">{{ title }}</div>
    <div class="panel_body">
      <ul v-loading="dataListLoading" class="list">
        <template v-for="(item, index) in dataList">
          <li :key="index" class="app_store-item" :class="index < 2 ? 'animate__fadeInLeft' : 'animate__fadeInRight'">
            <div>
              <img :src="item.img || defaultAppIcon" />
              <div class="label">{{ item.title }}</div>
              <div class="text">{{ htmlTextToText(item.content) }}</div>
              <div class="btn" @click.stop="openPage(item.id)">了解更多</div>
            </div>
          </li>
        </template>
      </ul>
      <div class="more" @click.stop="() => $router.push({ path: '/app-store/saas-app' })">查看更多应用>></div>
    </div>
  </div>
</template>
<script>
import ListMixin from "@/mixins/ListMixin";
import { getList } from "@/api/saasApp";
import { addWOW } from "@/utils";
export default {
  name: "app_store",
  mixins: [ListMixin],
  data() {
    return {
      title: "应用市场",
      listParams: { publishStatus: "Published", types: "1" },
      defaultAppIcon: require("@/assets/images/app-store/app-icon.png"),
      pagination: {
        size: 4,
      },
      api: {
        list: getList,
      },
    };
  },
  watch: {
    dataList: function () {
      addWOW("app_store-item");
    },
  },
  methods: {
    openPage(id) {
      this.$router.push({ path: "/app-store/saas-app", query: { types: "1", id } });
    },
  },
};
</script>
<style lang="less" scoped>
@import "./index.less";
</style>
